var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON - Discount"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94783 4.69565C4.5913 4.69565 3.91304 5.36299 3.91304 6.69767V7.29828C3.91304 8.63296 4.5913 9.3003 5.94783 9.3003C7.30435 9.3003 7.98261 8.63296 7.98261 7.29828V6.69767C7.98261 5.36299 7.30435 4.69565 5.94783 4.69565ZM6.82957 7.29828C6.82957 7.89889 6.55826 8.16582 5.94783 8.16582C5.33739 8.16582 5.06609 7.83215 5.06609 7.29828V6.69767C5.06609 6.09707 5.33739 5.83013 5.94783 5.83013C6.55826 5.83013 6.82957 6.09707 6.82957 6.69767V7.29828Z",
    fill: "#85A0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40522 12.9707L11.1026 4.96259H12.5948L6.89739 12.9707H5.40522Z",
    fill: "#85A0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0522 8.6997C10.6957 8.6997 10.0174 9.36704 10.0174 10.7017V11.3023C10.0174 12.637 10.6957 13.3043 12.0522 13.3043C13.4087 13.3043 14.087 12.637 14.087 11.3023V10.7017C14.087 9.36704 13.4087 8.6997 12.0522 8.6997ZM12.9339 11.2356C12.9339 11.8362 12.6626 12.1031 12.0522 12.1031C11.4417 12.1031 11.1704 11.8362 11.1704 11.2356V10.7017C11.1704 10.1011 11.4417 9.83418 12.0522 9.83418C12.6626 9.83418 12.9339 10.1011 12.9339 10.7017V11.2356Z",
    fill: "#85A0BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5217 1.4087H5.47826C3.2307 1.4087 1.4087 3.2307 1.4087 5.47826V12.5217C1.4087 14.7693 3.2307 16.5913 5.47826 16.5913H12.5217C14.7693 16.5913 16.5913 14.7693 16.5913 12.5217V5.47826C16.5913 3.2307 14.7693 1.4087 12.5217 1.4087ZM5.47826 0C2.4527 0 0 2.4527 0 5.47826V12.5217C0 15.5473 2.4527 18 5.47826 18H12.5217C15.5473 18 18 15.5473 18 12.5217V5.47826C18 2.4527 15.5473 0 12.5217 0H5.47826Z",
    fill: "#85A0BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscount);
export default __webpack_public_path__ + "static/media/ICON - Discount.419685a339e523e6c406d724194dcd7e.svg";
export { ForwardRef as ReactComponent };